module.exports = __webpack_public_path__ + "458e21f42eb6566b99ea5d3f1c818734.svg";